/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssetDetailCityResponseDto
 */
export interface AssetDetailCityResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AssetDetailCityResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AssetDetailCityResponseDto
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof AssetDetailCityResponseDto
     */
    name: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssetDetailCityResponseDto
     */
    postalCodes: Array<string>;
}

/**
 * Check if a given object implements the AssetDetailCityResponseDto interface.
 */
export function instanceOfAssetDetailCityResponseDto(value: object): value is AssetDetailCityResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('postalCodes' in value) || value['postalCodes'] === undefined) return false;
    return true;
}

export function AssetDetailCityResponseDtoFromJSON(json: any): AssetDetailCityResponseDto {
    return AssetDetailCityResponseDtoFromJSONTyped(json, false);
}

export function AssetDetailCityResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetDetailCityResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'code': json['code'],
        'name': json['name'],
        'postalCodes': json['postalCodes'],
    };
}

export function AssetDetailCityResponseDtoToJSON(json: any): AssetDetailCityResponseDto {
    return AssetDetailCityResponseDtoToJSONTyped(json, false);
}

export function AssetDetailCityResponseDtoToJSONTyped(value?: AssetDetailCityResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'code': value['code'],
        'name': value['name'],
        'postalCodes': value['postalCodes'],
    };
}

